import { Link } from 'react-router-dom';
import styled from 'styled-components';
import FunnelShell from './FunnelShell';

const Panel = styled.section`
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 14px;
  background: ${({ theme }) => theme.colors.gray050};
  padding: 1.2rem;
  display: grid;
  gap: 0.75rem;
`;

const Action = styled(Link)`
  text-decoration: none;
  border: 1px solid rgba(224, 161, 94, 0.58);
  background: transparent;
  color: #e0a15e;
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
  font-weight: 700;
  width: fit-content;

  &:hover {
    border-color: rgba(224, 161, 94, 0.85);
    background: rgba(224, 161, 94, 0.08);
  }
`;

export default function CheckoutCancelPage() {
  return (
    <FunnelShell>
      <Panel>
        <h1 style={{ margin: 0 }}>Checkout canceled</h1>
        <p style={{ margin: 0 }}>
          No payment was captured. Your selected package is still in your cart.
        </p>
        <Action to="/checkout">Return to checkout</Action>
      </Panel>
    </FunnelShell>
  );
}
